<template>
  <div class="fliter-item">
    <div class="header">
      {{ showTitle }}
      <div class="text" @click="toggleMore">
        <span :class="{ active: textShow !== '', ...themeAppColorClass }">{{
          textShow
        }}</span>
        <img
          v-if="listData.length > 9"
          :src="ifMore ? upwardIcon : downIcon"
          class="icon"
        />
      </div>
    </div>
    <ul class="cf" :style="{ 'max-height': maxHeight }">
      <li
        v-for="(item, index) in listData"
        :key="index"
        class="item"
        :class="activeClass(item)"
        @click="handleClick(item)"
      >
        <span :class="{ ...themeAppColorClass }">{{ item }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import downIcon from '@/images/activity_goods/down.png'
import upwardIcon from '@/images/activity_goods/upward.png'
import themeMixin from '@/common/mixins/theme'
export default {
  mixins: [themeMixin],
  // eslint-disable-next-line vue/require-prop-types
  props: ['tmpData', 'listData', 'callKey', 'showKey', 'showTitle'],
  data() {
    return {
      ifMore: false,
      downIcon,
      upwardIcon
    }
  },
  computed: {
    ...mapState('activityGoods', {
      filterOpen: state => state.filterOpen
    }),
    textShow() {
      let text = ''
      if (typeof this.tmpData === 'string') {
        if (this.tmpData) {
          text = this.tmpData
        }
      } else if (this.tmpData.length > 0) {
        text = []
        this.listData.forEach(item => {
          if (this.tmpData.includes(item)) {
            text.push(item)
          }
        })
        text = text.join(',')
      }

      return text
    },
    maxHeight() {
      if (!this.ifMore) {
        return Number(44 * 3) + 'px'
      } else {
        return Number(Math.floor(this.listData.length / 3 + 1) * 44) + 'px'
      }
    }
  },
  watch: {
    filterOpen: function (newVal, oldVal) {
      this.ifMore = false // 关闭筛选的时候初始化“更多”
    }
  },

  methods: {
    activeClass(item) {
      if (typeof this.tmpData === 'string') {
        return this.tmpData === item
          ? {
              active: true,
              ...this.themeAppColorClass
            }
          : ''
      } else {
        return this.tmpData.includes(item)
          ? {
              active: true,
              ...this.themeAppColorClass
            }
          : ''
      }
    },
    handleClick(item) {
      this.$emit('set-data', this.callKey, item)
    },
    toggleMore() {
      this.ifMore = !this.ifMore
    }
  }
}
</script>

<style lang="scss" scoped>
.fliter-item {
  padding: 0.4rem 0 0.08rem 0;

  ul {
    overflow: hidden;

    transition: max-height 0.6s;
    li {
      // display: inline-block;
      float: left;

      width: -webkit-calc(33.3% - 6px);
      height: 32px;
      margin: 6px 0;
      &:nth-child(3n + 2) {
        margin: 6px 9px;
      }
      span {
        display: block;

        height: 32px;
        overflow: hidden;

        background: #fff;
        border-radius: 0.32rem;
        border: 0.5px solid rgba(204, 204, 204, 0.6);

        font-size: 0.26rem;
        line-height: 32px;
        text-align: center;
        white-space: nowrap;
        color: #333333;

        text-overflow: ellipsis;

        word-break: break-all;
      }
      &.active span {
        background: #fff;
        border: 0.5px solid #0daf52;

        font-weight: 500;
        color: #0daf52;
        &.small {
          border-color: $theme-main_small;
          color: $theme-main_small;
        }
      }
    }
  }
  .header {
    display: -webkit-box;

    margin-bottom: 10px;

    font-size: 0.28rem;
    vertical-align: bottom;
    color: #4f5259;

    .text {
      display: flex;

      justify-content: flex-end;
      align-items: center;

      font-size: 0.24rem;
      text-align: right;
      color: #9f9f9f;

      // box-flex: 1;
      // -webkit-box-flex: 1;

      span {
        display: inline-block;

        width: 4.2rem;
        overflow: hidden;

        white-space: nowrap;

        text-overflow: ellipsis;
        &.active {
          color: #0daf52;
          &.small {
            color: $theme-main_small;
          }
        }
      }
      .icon {
        height: 0.14rem;
        margin-left: 0.1rem;
      }
    }
  }
}
</style>
